var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHslLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106.37,
    height: 42.207,
    viewBox: "0 0 106.37 42.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140159",
    "data-name": "Path 140159",
    d: "M0-5.982H106.371V-48.189H0Z",
    transform: "translate(0 48.189)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140184",
    "data-name": "Path 140184",
    d: "M0-26H39.724v-7.235H0Z",
    transform: "translate(0 33.231)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.063,
    y1: 1.148,
    x2: 0.883,
    y2: 1.148,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f23046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ea2f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e22d41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#da2c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d22b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ca2a38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c32836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#bb2733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b42631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ad252f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6242c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140186",
    "data-name": "Path 140186",
    d: "M14.883-14.875h6.826v-33.3H14.883Z",
    transform: "translate(-14.883 48.172)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140188",
    "data-name": "Path 140188",
    d: "M37.858-48.189V-21.71a6.956,6.956,0,0,0,6.956,6.957H73.1A8.447,8.447,0,0,0,81.546-23.2h0v-4.249a7.566,7.566,0,0,0-7.566-7.565H59.612a3.145,3.145,0,0,1-3.145-3.145h0v-.812a3.144,3.144,0,0,1,3.145-3.145H83.657a2.452,2.452,0,0,1,2.452,2.452h0v24.911h24.96v-7.054H93.579V-41.374a6.551,6.551,0,0,0-6.551-6.552H57.859a8.446,8.446,0,0,0-8.446,8.446h0v2.244a8.446,8.446,0,0,0,8.446,8.446H71.345a3.146,3.146,0,0,1,3.145,3.145h0v1.521a3.144,3.144,0,0,1-3.145,3.145h-23.5A3.346,3.346,0,0,1,44.5-24.323h0V-48.189Z",
    transform: "translate(-37.858 48.189)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28880",
    "data-name": "Group 28880",
    transform: "translate(-1169 -204.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28879",
    "data-name": "Group 28879",
    transform: "translate(1169 204.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28849",
    "data-name": "Group 28849",
    transform: "translate(13.037 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140155",
    "data-name": "Path 140155",
    d: "M-.285,0V1.394H-1.8V0h-.5V3.436h.5V1.808H-.285V3.436h.5V0Z",
    transform: "translate(2.297)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28853",
    "data-name": "Group 28853",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28850",
    "data-name": "Group 28850",
    transform: "translate(17.498 38.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140156",
    "data-name": "Path 140156",
    d: "M-.2,0A2.041,2.041,0,0,1,.449.089.881.881,0,0,1,.874.384a1.315,1.315,0,0,1,.232.547,4.234,4.234,0,0,1,.072.851,4.246,4.246,0,0,1-.072.85,1.322,1.322,0,0,1-.232.55.88.88,0,0,1-.426.293A2.041,2.041,0,0,1-.2,3.565a2.037,2.037,0,0,1-.645-.089.9.9,0,0,1-.428-.293,1.335,1.335,0,0,1-.236-.55,4.1,4.1,0,0,1-.074-.85A4.09,4.09,0,0,1-1.506.931,1.328,1.328,0,0,1-1.269.384.9.9,0,0,1-.841.089,2.037,2.037,0,0,1-.2,0m0,.434A.923.923,0,0,0-.709.558.68.68,0,0,0-.976.973a3.3,3.3,0,0,0-.077.809,3.3,3.3,0,0,0,.077.807.683.683,0,0,0,.266.419A.923.923,0,0,0-.2,3.132a.91.91,0,0,0,.511-.124.7.7,0,0,0,.266-.419,3.237,3.237,0,0,0,.08-.807A3.241,3.241,0,0,0,.581.973.7.7,0,0,0,.315.558.91.91,0,0,0-.2.434",
    transform: "translate(1.58)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28851",
    "data-name": "Group 28851",
    transform: "translate(22.064 38.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140157",
    "data-name": "Path 140157",
    d: "M-.162,0C0,0,.176.011.353.025A3.788,3.788,0,0,1,.884.1L.849.458C.706.451.546.447.368.443S.02.438-.147.438c-.116,0-.215,0-.3.011A.486.486,0,0,0-.649.5.265.265,0,0,0-.767.647.817.817,0,0,0-.8.921a.54.54,0,0,0,.1.37.642.642,0,0,0,.324.162l.692.184a.857.857,0,0,1,.547.336,1.177,1.177,0,0,1,.15.635,1.439,1.439,0,0,1-.067.483.57.57,0,0,1-.209.284.913.913,0,0,1-.365.14,3.131,3.131,0,0,1-.533.039c-.113,0-.262-.005-.448-.015a4.8,4.8,0,0,1-.643-.085l.035-.363.481.018q.187.008.321.008h.269A1.6,1.6,0,0,0,.241,3.08a.3.3,0,0,0,.2-.149A.72.72,0,0,0,.506,2.6a.758.758,0,0,0-.043-.286.322.322,0,0,0-.134-.157.891.891,0,0,0-.236-.089L-.62,1.877a.851.851,0,0,1-.53-.334A1.136,1.136,0,0,1-1.3.916,1.439,1.439,0,0,1-1.235.434.538.538,0,0,1-1.028.157.874.874,0,0,1-.675.032,3.456,3.456,0,0,1-.162,0",
    transform: "translate(1.302)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28852",
    "data-name": "Group 28852",
    transform: "translate(26.281 38.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140158",
    "data-name": "Path 140158",
    d: "M-.171,0A1.938,1.938,0,0,1,.5.095.616.616,0,0,1,.857.423a1.643,1.643,0,0,1,.107.662,1.685,1.685,0,0,1-.1.66.6.6,0,0,1-.342.328,1.772,1.772,0,0,1-.63.092c-.143,0-.279,0-.411-.01s-.251-.017-.361-.03-.2-.028-.281-.043a.86.86,0,0,1-.162-.042l.015-.289H-.176A1.124,1.124,0,0,0,.2,1.693a.349.349,0,0,0,.2-.2,1.118,1.118,0,0,0,.06-.409A1.134,1.134,0,0,0,.4.672.361.361,0,0,0,.2.47,1.03,1.03,0,0,0-.176.413Q-.594.413-.9.419c-.2,0-.339.008-.408.015l-.07-.389c.126-.013.246-.023.359-.03S-.781,0-.649,0s.293,0,.478,0M-.878,3.481h-.5V.045h.5Z",
    transform: "translate(1.376)",
    fill: "#435861"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140160",
    "data-name": "Path 140160",
    d: "M34.81-.561h.5V-4h-.5Z",
    transform: "translate(-4.321 42.704)",
    fill: "#435861"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28854",
    "data-name": "Group 28854",
    transform: "translate(32.765 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140161",
    "data-name": "Path 140161",
    d: "M-.225,0H-1.813V.429h1.09V3.436h.5V.429h1.1V0Z",
    transform: "translate(1.813)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28861",
    "data-name": "Group 28861",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28855",
    "data-name": "Group 28855",
    transform: "translate(36.554 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140162",
    "data-name": "Path 140162",
    d: "M-.252,0A.184.184,0,0,1-.137.038a.192.192,0,0,1,.069.1l1.086,3.3H.5L-.356.672C-.37.625-.383.577-.4.526S-.423.427-.436.384h-.14Q-.6.448-.615.526c-.013.052-.028.1-.045.146l-.857,2.764H-2.03L-.944.134a.192.192,0,0,1,.069-.1A.184.184,0,0,1-.76,0ZM.366,2.39H-1.387V1.977H.366Z",
    transform: "translate(2.03)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28856",
    "data-name": "Group 28856",
    transform: "translate(41.294 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140163",
    "data-name": "Path 140163",
    d: "M-.07,0V2.709a.315.315,0,0,0,.08.236.338.338,0,0,0,.244.077h1.23l.025.384c-.222.017-.448.026-.677.03s-.458,0-.688,0A.689.689,0,0,1-.4,3.254a.686.686,0,0,1-.165-.47V0Z",
    transform: "translate(0.563)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28857",
    "data-name": "Group 28857",
    transform: "translate(47.187 38.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140164",
    "data-name": "Path 140164",
    d: "M-.162,0C0,0,.176.011.353.025A3.788,3.788,0,0,1,.884.1L.849.458C.706.451.546.447.368.443S.02.438-.147.438c-.116,0-.215,0-.3.011A.486.486,0,0,0-.649.5.265.265,0,0,0-.767.647.817.817,0,0,0-.8.921a.54.54,0,0,0,.1.37.642.642,0,0,0,.324.162l.692.184a.857.857,0,0,1,.547.336,1.177,1.177,0,0,1,.15.635,1.439,1.439,0,0,1-.067.483.57.57,0,0,1-.209.284.913.913,0,0,1-.365.14,3.131,3.131,0,0,1-.533.039c-.113,0-.262-.005-.448-.015a4.8,4.8,0,0,1-.643-.085l.035-.363.481.018q.187.008.321.008h.269A1.6,1.6,0,0,0,.241,3.08a.3.3,0,0,0,.2-.149A.72.72,0,0,0,.506,2.6a.758.758,0,0,0-.043-.286.322.322,0,0,0-.134-.157.891.891,0,0,0-.236-.089L-.62,1.877a.851.851,0,0,1-.53-.334A1.136,1.136,0,0,1-1.3.916,1.439,1.439,0,0,1-1.235.434.538.538,0,0,1-1.028.157.874.874,0,0,1-.675.032,3.456,3.456,0,0,1-.162,0",
    transform: "translate(1.302)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28858",
    "data-name": "Group 28858",
    transform: "translate(51.375 38.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140165",
    "data-name": "Path 140165",
    d: "M-.1,0H.412C.585,0,.755,0,.923.008S1.25.02,1.4.03l-.02.384H.014A.285.285,0,0,0-.205.488a.344.344,0,0,0-.07.239V2.719a.354.354,0,0,0,.07.242.28.28,0,0,0,.219.077H1.383l.02.378c-.152.01-.313.017-.48.02s-.338.005-.511.007l-.508,0a.7.7,0,0,1-.49-.166.593.593,0,0,1-.187-.446V.612A.589.589,0,0,1-.586.165.7.7,0,0,1-.1,0M-.684,1.439H1.189v.388H-.684Z",
    transform: "translate(0.773)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28859",
    "data-name": "Group 28859",
    transform: "translate(55.453 38.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140166",
    "data-name": "Path 140166",
    d: "M-.172,0a2.039,2.039,0,0,1,.66.088.623.623,0,0,1,.366.3A1.314,1.314,0,0,1,.969,1,1.4,1.4,0,0,1,.9,1.454a.607.607,0,0,1-.2.289.765.765,0,0,1-.371.134V1.9a.471.471,0,0,1,.169.08.68.68,0,0,1,.159.161A.681.681,0,0,1,.769,2.4l.324,1.081H.565l-.3-1.07A.524.524,0,0,0,.1,2.142a.439.439,0,0,0-.274-.08c-.209,0-.388,0-.538,0s-.275,0-.376-.008-.184,0-.247,0l.015-.4H-.181A1.193,1.193,0,0,0,.2,1.591.348.348,0,0,0,.4,1.4a.927.927,0,0,0,.062-.378A.908.908,0,0,0,.4.65.352.352,0,0,0,.2.466,1.119,1.119,0,0,0-.181.413Q-.6.413-.9.419l-.408,0L-1.381.045c.126-.013.245-.023.358-.03S-.786,0-.652,0s.3,0,.481,0M-.889,3.481h-.493V.045h.493Z",
    transform: "translate(1.382)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28860",
    "data-name": "Group 28860",
    transform: "translate(59.436 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140167",
    "data-name": "Path 140167",
    d: "M-.413,0-1.438,3.3a.23.23,0,0,1-.07.1.168.168,0,0,1-.114.043h-.493a.177.177,0,0,1-.12-.043A.227.227,0,0,1-2.3,3.3L-3.326,0h.518l.777,2.679.05.187q.025.092.045.187H-1.8q.02-.095.045-.189t.055-.189L-.93,0Z",
    transform: "translate(3.326)",
    fill: "#435861"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140169",
    "data-name": "Path 140169",
    d: "M73.17-.561h.5V-4h-.5Z",
    transform: "translate(-9.082 42.704)",
    fill: "#435861"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28866",
    "data-name": "Group 28866",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28862",
    "data-name": "Group 28862",
    transform: "translate(66.538 38.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140170",
    "data-name": "Path 140170",
    d: "M-.194,0c.15,0,.277,0,.384.01s.2.018.293.032A2.847,2.847,0,0,1,.762.1L.713.478C.613.468.52.461.433.455L.157.443C.059.44-.058.438-.194.438A.891.891,0,0,0-.7.562.693.693,0,0,0-.959.978a3.3,3.3,0,0,0-.077.8,3.292,3.292,0,0,0,.077.8A.693.693,0,0,0-.7,2.993a.884.884,0,0,0,.5.124c.215,0,.4,0,.545-.012s.292-.023.431-.043l.05.374a2.753,2.753,0,0,1-.45.092,5.024,5.024,0,0,1-.575.027,1.6,1.6,0,0,1-.8-.172.98.98,0,0,1-.436-.561,3.294,3.294,0,0,1-.134-1.045A3.3,3.3,0,0,1-1.429.732.98.98,0,0,1-.993.172,1.6,1.6,0,0,1-.194,0",
    transform: "translate(1.563)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28863",
    "data-name": "Group 28863",
    transform: "translate(70.735 38.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140171",
    "data-name": "Path 140171",
    d: "M-.1,0H.412C.585,0,.755,0,.923.008S1.25.02,1.4.03l-.02.384H.014A.285.285,0,0,0-.205.488a.344.344,0,0,0-.07.239V2.719a.354.354,0,0,0,.07.242.28.28,0,0,0,.219.077H1.383l.02.378c-.152.01-.313.017-.48.02s-.338.005-.511.007l-.508,0a.7.7,0,0,1-.49-.166.593.593,0,0,1-.187-.446V.612A.589.589,0,0,1-.586.165.7.7,0,0,1-.1,0M-.684,1.439H1.189v.388H-.684Z",
    transform: "translate(0.773)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28864",
    "data-name": "Group 28864",
    transform: "translate(74.658 38.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140172",
    "data-name": "Path 140172",
    d: "M-.162,0C0,0,.176.011.353.025A3.788,3.788,0,0,1,.884.1L.849.458C.706.451.546.447.368.443S.02.438-.147.438c-.116,0-.215,0-.3.011A.486.486,0,0,0-.649.5.265.265,0,0,0-.767.647.817.817,0,0,0-.8.921a.54.54,0,0,0,.1.37.642.642,0,0,0,.324.162l.692.184a.857.857,0,0,1,.547.336,1.177,1.177,0,0,1,.15.635,1.439,1.439,0,0,1-.067.483.57.57,0,0,1-.209.284.913.913,0,0,1-.365.14,3.131,3.131,0,0,1-.533.039c-.113,0-.262-.005-.448-.015a4.8,4.8,0,0,1-.643-.085l.035-.363.481.018q.187.008.321.008h.269A1.6,1.6,0,0,0,.241,3.08a.3.3,0,0,0,.2-.149A.72.72,0,0,0,.506,2.6a.778.778,0,0,0-.042-.286.328.328,0,0,0-.135-.157.891.891,0,0,0-.236-.089L-.62,1.877a.851.851,0,0,1-.53-.334A1.136,1.136,0,0,1-1.3.916,1.439,1.439,0,0,1-1.235.434.538.538,0,0,1-1.028.157.874.874,0,0,1-.675.032,3.456,3.456,0,0,1-.162,0",
    transform: "translate(1.302)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28865",
    "data-name": "Group 28865",
    transform: "translate(80.863 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140173",
    "data-name": "Path 140173",
    d: "M-.07,0V2.709a.315.315,0,0,0,.08.236.338.338,0,0,0,.244.077h1.23l.025.384c-.222.017-.448.026-.677.03s-.458,0-.688,0A.689.689,0,0,1-.4,3.254a.686.686,0,0,1-.165-.47V0Z",
    transform: "translate(0.563)",
    fill: "#435861"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140175",
    "data-name": "Path 140175",
    d: "M96.7-.561h.5V-4h-.5Z",
    transform: "translate(-12.003 42.704)",
    fill: "#435861"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28868",
    "data-name": "Group 28868",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28867",
    "data-name": "Group 28867",
    transform: "translate(87.207 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140176",
    "data-name": "Path 140176",
    d: "M-.477,0c.13,0,.2.068.2.2l.14,3.232H-.627L-.751.4h-.1l-.727,2.466a.2.2,0,0,1-.209.164h-.408a.2.2,0,0,1-.219-.164L-3.141.4h-.1l-.115,3.033h-.488L-3.709.2c.007-.136.074-.2.2-.2h.538a.2.2,0,0,1,.209.165l.6,2.031a1.833,1.833,0,0,1,.065.229q.025.114.06.239h.084c.024-.083.044-.163.062-.239s.039-.156.062-.239l.6-2.022A.2.2,0,0,1-1.015,0Z",
    transform: "translate(3.843 0)",
    fill: "#435861"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140178",
    "data-name": "Path 140178",
    d: "M106.092-.561h.5V-4h-.5Z",
    transform: "translate(-13.169 42.704)",
    fill: "#435861"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28869",
    "data-name": "Group 28869",
    transform: "translate(95.199 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140179",
    "data-name": "Path 140179",
    d: "M-.225,0H-1.813V.429h1.09V3.436h.5V.429H.87V0Z",
    transform: "translate(1.813)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28872",
    "data-name": "Group 28872",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28870",
    "data-name": "Group 28870",
    transform: "translate(99.63 38.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140180",
    "data-name": "Path 140180",
    d: "M-.1,0H.412C.585,0,.755,0,.923.008S1.25.02,1.4.03l-.02.384H.014A.285.285,0,0,0-.205.488a.344.344,0,0,0-.07.239V2.719a.354.354,0,0,0,.07.242.28.28,0,0,0,.219.077H1.383l.02.378c-.152.01-.313.017-.48.02s-.338.005-.511.007l-.508,0a.7.7,0,0,1-.49-.166.593.593,0,0,1-.187-.446V.612A.589.589,0,0,1-.586.165.7.7,0,0,1-.1,0M-.684,1.439H1.189v.388H-.684Z",
    transform: "translate(0.773)",
    fill: "#435861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28871",
    "data-name": "Group 28871",
    transform: "translate(103.709 38.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140181",
    "data-name": "Path 140181",
    d: "M-.176,0a2,2,0,0,1,.64.089.89.89,0,0,1,.42.292,1.3,1.3,0,0,1,.231.543,4.121,4.121,0,0,1,.073.839,4.112,4.112,0,0,1-.073.838,1.3,1.3,0,0,1-.231.543.89.89,0,0,1-.42.292,2,2,0,0,1-.64.089q-.359,0-.665-.012t-.58-.032l.208-.4c.14.007.3.012.466.018s.361.008.57.008a.884.884,0,0,0,.5-.125.691.691,0,0,0,.262-.415,3.32,3.32,0,0,0,.077-.8,3.323,3.323,0,0,0-.077-.8A.691.691,0,0,0,.326.543a.884.884,0,0,0-.5-.124l-.553,0-.478.008L-1.421.045q.273-.02.58-.032T-.176,0M-.924,3.481h-.5V.045h.5Z",
    transform: "translate(1.421)",
    fill: "#435861"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28874",
    "data-name": "Group 28874",
    transform: "translate(0 13.101)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28873",
    "data-name": "Group 28873",
    transform: "translate(0.047 -15.328) rotate(1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140183",
    "data-name": "Path 140183",
    d: "M0,2.228,106.347,0l.884,42.2L.884,44.426Z",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28876",
    "data-name": "Group 28876",
    transform: "translate(13.036 0.015)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28875",
    "data-name": "Group 28875",
    transform: "translate(-12.989 -2.242) rotate(1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140185",
    "data-name": "Path 140185",
    d: "M0,2.228,106.347,0l.884,42.2L.884,44.426Z",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28878",
    "data-name": "Group 28878",
    transform: "translate(33.159 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28877",
    "data-name": "Group 28877",
    transform: "translate(-33.112 -2.227) rotate(1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140187",
    "data-name": "Path 140187",
    d: "M0,2.228,106.347,0l.884,42.2L.884,44.426Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHslLogo);
export default __webpack_public_path__ + "static/media/hsl-logo.1439610dd35580e589c967dd9c73efcd.svg";
export { ForwardRef as ReactComponent };